var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customfields-history" },
    [
      _vm.enabled
        ? _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("CustomfieldsHistory.button.label"),
              type: "secondary",
              size: "small",
              leftIcon: "history"
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.openHistory($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }